import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { apiService } from '../../services/apiService';
function ViewCommunityMember() {
    const navigate = useNavigate();
    const { userid } = useParams();
    const [loading, setLoading] = useState(true);
    const [userdatas, setDatas] = useState([]);
    useEffect(() => {
        const fetchCurrentData = async () => {
            try {
            const response = await apiService.getRequest(`/community-members/${userid}`);
            if (response.success && response.success === true) {
                setDatas(response.data);
            }
            } catch (error) {
                console.error("Error fetching onboarding data:", error);
            } finally {
                setLoading(false);
            }
        };
    
        fetchCurrentData();
    }, [ userid ]);
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{xs:12}} container justifyContent="space-between">
                        <Grid container flexDirection="column" className="jobseekerhead">
                            <h3>Community Member</h3>
                            <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/community-member")}>Community Member</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> View Community Member</span>
                        </Grid>
                        <Grid container flexDirection="column" className="jobseekerhead">
                            <button className='registersendbtn1 my-0' onClick={()=>navigate('/community-member')}>Back</button>
                        </Grid>
                    </Grid>
                    {loading ? 
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :<>
                        <Grid size={{ sm:6,xs:12}} container className="mt-5">
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>ID Number</span>
                                <span className='blue_linkviewmember'>{userdatas.formatted_id || "-" }</span>
                            </Grid>
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Source</span>
                                {userdatas && userdatas.source.map((sources,index)=>(
                                    <span key={index} className='black_linkviewmember'>{sources}</span>
                                ))}
                            </Grid>
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Name</span>
                                <span className='black_linkviewmember'>{userdatas.full_name || "-" }</span>
                            </Grid>
                            {userdatas && userdatas.referred_by && userdatas.referred_by.full_name.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Referred by</span>
                                <span className='fullblue_linkviewmember cursetespoint' onClick={() => window.open(`/community-member/view/${userdatas.referred_by && userdatas.referred_by.formatted_id}`, '_blank')}>{userdatas && userdatas.referred_by && userdatas.referred_by.full_name}</span>
                            </Grid>}
                            {userdatas && userdatas.phone_number && userdatas.phone_number.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Primary Phone</span>
                                <span className='black_linkviewmember'>{userdatas.phone_number || "-" }</span>
                            </Grid>}
                            {userdatas && userdatas.secondary_phone_number && userdatas.secondary_phone_number.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Secondary Phone</span>
                                <span className='black_linkviewmember'>{userdatas.secondary_phone_number || "-" }</span>
                            </Grid>
                            }
                            {userdatas && userdatas.other_phone_number && userdatas.other_phone_number.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Other Phone</span>
                                <span className='black_linkviewmember'>{userdatas.other_phone_number || "-" }</span>
                            </Grid>
                            }
                            {userdatas && userdatas.email && userdatas.email.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Primary Email</span>
                                <span className='black_linkviewmember'>{userdatas.email || "-" }</span>
                            </Grid>}
                            {userdatas && userdatas.secondary_email && userdatas.secondary_email.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Secondary Email</span>
                                <span className='black_linkviewmember'>{userdatas.secondary_email || "-" }</span>
                            </Grid>
                            }
                            {userdatas && userdatas.other_email && userdatas.other_email.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Other Email</span>
                                <span className='black_linkviewmember'>{userdatas.other_email || "-" }</span>
                            </Grid>
                            }
                            {userdatas && userdatas.living_city && userdatas.living_city.name.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Living City</span>
                                <span className='black_linkviewmember'>{userdatas && userdatas.living_city && userdatas.living_city.name}</span>
                            </Grid>
                            }
                            {userdatas && userdatas.living_state && userdatas.living_state.name.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Living State</span>
                                <span className='black_linkviewmember'>{userdatas && userdatas.living_state && userdatas.living_state.name}</span>
                            </Grid>}
                            {userdatas && userdatas.living_country && userdatas.living_country.name.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Living Country</span>
                                <span className='black_linkviewmember'>{userdatas && userdatas.living_country && userdatas.living_country.name}</span>
                            </Grid>}
                            {userdatas && userdatas.level && userdatas.level.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Level</span>
                                <span className='black_linkviewmember'>{userdatas.level || "-" }</span>
                            </Grid>}
                            {userdatas && userdatas.comments && userdatas.comments.length > 0 &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Relationship with Referrer</span>
                                <span className='black_linkviewmember'>{userdatas.comments || "-" }</span>
                            </Grid>}
                            {userdatas.accepted_professional_references === 'Yes' &&
                            <>
                            <Grid size={{sm:12, xs:12}} container flexDirection="column" className="mt-3">
                                <h5 className='fw-semibold' style={{color:"#C42B7D"}}>Professional Information</h5>
                            </Grid>
                            {userdatas?.prof_current_company_name &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Current Company Name</span>
                                <span className='black_linkviewmember'>{userdatas?.prof_current_company_name || "-" }</span>
                            </Grid>}
                            {userdatas?.prof_contact_number &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Contact Number</span>
                                <span className='black_linkviewmember'>{userdatas?.prof_contact_number || "-" }</span>
                            </Grid>}
                            {userdatas?.prof_personal_email &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Personal Email</span>
                                <span className='black_linkviewmember'>{userdatas?.prof_personal_email || "-" }</span>
                            </Grid>}
                            {userdatas?.prof_work_email &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Work Email</span>
                                <span className='black_linkviewmember'>{userdatas?.prof_work_email || "-" }</span>
                            </Grid>}
                            {userdatas?.prof_linkedin_url &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>LinkedIn URL</span>
                                {userdatas?.prof_linkedin_url ? 
                                    <Link className='fullblue_linkviewmember cursetespoint' to={userdatas?.prof_linkedin_url} target='_blank'>View</Link>:
                                    <span className='black_linkviewmember'>{userdatas?.prof_linkedin_url || "-" }</span>
                                }
                            </Grid>}
                            {userdatas?.prof_current_job_title &&
                            <Grid size={{ sm:6,xs:12}} container flexDirection="column" className="my-3">
                                <span className='gray_viewmember'>Current Job Title</span>
                                <span className='black_linkviewmember'>{userdatas?.prof_current_job_title || "-" }</span>
                            </Grid>}
                            </>}
                        </Grid>
                    </>}
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default ViewCommunityMember
